import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { StorageService } from "../../services/storage.service";
import { AppLogo1 } from "../../app.config";
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "../../../assets/img/icons/common/dashboard.svg",
    class: "",
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  closeResult: string;
  public menuItems: any[];
  public isCollapsed = true;
  appLogo = AppLogo1;

  constructor(
    private storageService: StorageService,
    private router: Router,
    private modalService: NgbModal
  ) {}
  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true, size: "sm" });
  }
  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
  }
}
